export const SPRING_BREAK_DEALS_PATH =
  "/deals/spring-break-vacation-rentals-2026"
const NORMALIZED_SPRING_BREAK_ROUTES = new Set<string>([
  SPRING_BREAK_DEALS_PATH,
])

const normalizePathname = (pathname: string) => {
  if (pathname === "/") return pathname
  return pathname.replace(/\/+$/, "")
}

export const isSpringBreakDealsRoute = (pathname?: string | null): boolean => {
  if (!pathname) return false
  return NORMALIZED_SPRING_BREAK_ROUTES.has(normalizePathname(pathname))
}
